import React from "react";
import ReactHtmlParser from 'html-react-parser';

const compatibilityParams = Object.create(null);
const userAgent = navigator.userAgent || window.navigator.vendor || window.opera || ""
    , platform = navigator.platform || ""
    , maxTouchPoints = navigator.maxTouchPoints || 1;

const _ua = userAgent.toLowerCase();
const isAndroid = /android/.test(_ua);
const isIOS = /\b(ipod|iphone|ipad)(?=;)/.test(_ua) || (platform === "MacIntel" && maxTouchPoints > 1);
const isKakao = /kakaotalk/.test(_ua);
const isKaKaoBiz = /bizwebview/.test(_ua);
const isSamsung = /samsung/.test(_ua);
const isWebOS = /Android/.test(_ua);
const isBlackBerry = /BlackBerry/.test(_ua);
const isWindowsPhone = /Windows Phone/.test(_ua);

export const getBrowser = () => {
    return {
        isMobile: false,
        name: "",
        os: ""
    }
};

// 이벤트 관련
export const stopEvent = (event) => {
    if (event && event.preventDefault) {
        event.preventDefault();
    }

    if (event && event.stopPropagation) {
        event.stopPropagation();
    }
};

// 복사 관련
export const copyHTML = (value) => {
    if (!document.queryCommandSupported("copy")) {
        return false;
    }

    const element = document.createElement("input");
    element.style.position = 'absolute';
    element.style.opacity = '0';
    document.body.appendChild(element);

    element.value = value;
    element.focus();
    element.select();
    document.execCommand('copy');

    element.remove();
    return true;
};

//jsx 관련
export const HTMLParser = (text) => {
    return (
        <>
            {ReactHtmlParser(text)}
        </>
    );
};

export const Image = ({src, style = {}}) => {
    return <img src={src}
                style={style}
                alt=""/>
};

export const Emoji = ({name, icon, emoji, img, style = {}, img_style = {}}) => {
    if (img) {
        return <img src={img}
                    style={img_style}
                    alt=""/>
    } else if (emoji) {
        return <span className="tossface" style={style}>{emoji}</span>
    }

    return null;
};

export const removeLoading = () => {
    setTimeout(() => {
        const element = document.getElementById("into-loading");
        if (element) {
            element.remove();
        }
    }, 1000);
};

export const exitBrowser = () => {
    if (isKakao) {
        //kakaotalk
        window.location.href = "kakaotalk://web/close";
        setTimeout(() => {
            window.location.href = (isIOS) ? 'kakaoweb://closeBrowser' : 'kakaotalk://inappbrowser/close';
            window.close();
        }, 100)
    } else if (isIOS) {
        //ios
        window.open('', '_self', '')
        window.close();
    } else {
        window.open("about:blank", "_self");
        window.close();
    }
}

export const getUrlParams = () => {
    const params = {};
    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,
        function (str, key, value) {
            params[key] = value;
        }
    );

    return params;
}